export default "__VITE_ASSET__110570c7__"